import React from "react";

export class Obavijest extends React.Component {
    render() {
        var obavijest = "";
        if (this.props.userChecked && this.props.user && this.props.user.obavijesti.length) {
            this.props.user.obavijesti.map(x => {
                if (x.indexOf("BonusMoney-") == 0) {
                    obavijest = x;
                }
            })
        }

        if (obavijest.indexOf("BonusMoney-") == 0) {
            var iznos = casino.utils.numberToKune(casino.utils.stringToNumber(obavijest.slice(11)));
            return <div className="overlay">
                <div className="overlay--content lova-na-racunu">
                    <h2>Čestitamo</h2>
                    <div className="">
                        <span className="">
                            Pridodan vam je bonus od  <span className="text-bold marked">{iznos}.</span>
                        </span>
                    </div>
                    <div >
                        <div className="">
                            <span className="">
                                Trenutni saldo Casino računa iznosi: <span className="text-bold marked">{this.props.user && casino.utils.numberToKune(this.props.user.casinoRaspolozivo)}.</span>
                            </span>
                        </div>
                        <br />
                        <div className="">
                            <button onClick={this.props.fetchUserFn} className="link  padding-nula"><span className="text-bold">NASTAVI</span></button>
                        </div>
                    </div>
                </div>
            </div>
        }
        return null;
    }
};
